import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return "Conditions générales de vente topela"
}